










































































































































































import { Component, Vue} from 'vue-property-decorator'; // デコレータ
// 2023.07.04 [2023F-02] upd start
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import { AuthoritiesId } from '@/CommonUtils/fixed/AuthoritiesId';
// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

@Component
export default class KanriMenu extends ApiAccessBase {
  private orgFlg: boolean = false;
  private mstFlg: boolean = false;
  // 2023.11.16 [2023L-08] add start
  private mssFlg: boolean = false;
  // 2023.11.16 [2023L-08] add end
  private created() {
    this.orgFlg = this.checkAuthority(AuthoritiesId.ORG_READ);
    this.mstFlg = this.checkAuthority(AuthoritiesId.MST_READ);
    // 2023.11.16 [2023L-08] add start
    this.mssFlg = this.checkAuthority(AuthoritiesId.MSS_READ);
    // 2023.11.16 [2023L-08] add end
  }
}
//  2023.07.04 [2023F-02] upd end
